import { Component } from '@angular/core';

import { MegaoctetComponent } from '@camelot/ui';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'size-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [MegaoctetComponent],
  template: `<div class="align-center" style="height: 100%">
    <cam-megaoctet [octet]="this.value ?? 0"></cam-megaoctet>
  </div>`,
})
export class SizeCellComponent extends AbstractCellComponent<any, number> {}
